import {useIntl} from 'react-intl';
import {Alert} from 'react-bootstrap';

import styles from './styles.module.css';

export const BadConnection = () => {
    const {formatMessage} = useIntl();

    return (
        <Alert bsStyle='danger' className={styles.wrapper}>
            {formatMessage({
                id: 'create_post.bad_connection',
                defaultMessage: 'Please check connection, Time unreachable',
            })}
        </Alert>
    );
};
